import { useEffect, useMemo, useState } from "react"

export function resolveVirtualTournamentTargetMs(
  nextStartAt: string,
  msUntilStart: number
): number {
  if (nextStartAt) {
    const parsed = Date.parse(nextStartAt)
    if (Number.isFinite(parsed)) return parsed
  }
  return Date.now() + Math.max(0, msUntilStart)
}

export function useVirtualTournamentCountdownMs(
  nextStartAt: string,
  msUntilStart: number
): number {
  const targetMs = useMemo(
    () => resolveVirtualTournamentTargetMs(nextStartAt, msUntilStart),
    [nextStartAt, msUntilStart]
  )

  const [remainingMs, setRemainingMs] = useState(() =>
    Math.max(0, targetMs - Date.now())
  )

  useEffect(() => {
    setRemainingMs(Math.max(0, targetMs - Date.now()))
    const timer = setInterval(() => {
      setRemainingMs(Math.max(0, targetMs - Date.now()))
    }, 1000)
    return () => clearInterval(timer)
  }, [targetMs])

  return remainingMs
}
